function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Withdraw-Funds---check---review-",
  transform: "translate(-788.000000, -189.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(773.000000, 81.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(15.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Deposit-status",
  transform: "translate(0.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F0F5F6",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Credit-card",
  transform: "translate(12.000000, 13.000000)",
  fill: "#C9D6DB",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.3200891,0.0349603921 C11.9507735,-0.0675838595 12.6024185,0.0576606776 13.1239573,0.381659345 C13.6454961,0.705658013 13.9916377,1.20027436 14.0821381,1.75084458 C13.9500139,1.73618721 13.8169439,1.7288632 13.6837416,1.72891733 L13.6837416,1.72891733 L4.43183545,1.72684765 C3.90880262,1.82809838 3.97180513,2.47012001 4.57906459,2.47012001 L13.6837416,2.47012001 C14.9427254,2.47131146 15.9629905,3.35554121 15.9643653,4.44666047 L15.9643653,4.44666047 L15.9643653,10.3762818 C15.9629905,11.4674011 14.9427254,12.3516308 13.6837416,12.3528223 L13.6837416,12.3528223 L2.28062361,12.3528223 C1.02163985,12.3516308 0.00137475925,11.4674011 -2.83328916e-13,10.3762818 L-2.83328916e-13,10.3762818 L-2.83328916e-13,4.44666047 C0.000101785892,4.36587501 0.00578890801,4.28622369 0.0167447211,4.20798091 L0.0178173719,3.45839024 C0.0178173719,2.80916744 0.420231401,1.73387762 1.79923632,1.4482359 L1.93140312,1.42255356 L1.94209354,1.42255356 L1.92962138,1.42409773 C2.05931508,1.40301655 2.18887658,1.38410581 2.31695832,1.36714207 Z M11.9910913,6.42320093 C11.3613145,6.42320093 10.8507795,6.86566458 10.8507795,7.41147116 C10.8507795,7.95727773 11.3613145,8.39974139 11.9910913,8.39974139 C12.6208681,8.39974139 13.1314031,7.95727773 13.1314031,7.41147116 C13.1314031,6.86566458 12.6208681,6.42320093 11.9910913,6.42320093 Z",
  id: "Combined-Shape"
}))))))));

var SvgWalletRound = function SvgWalletRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalletRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet-round.8bffba21.svg";
export { ForwardRef as ReactComponent };